/**
 * Offline Support Utilities
 * 오프라인 지원 유틸리티
 */

const CACHE_NAME = 'kaching-cache-v1'
const API_CACHE_NAME = 'kaching-api-cache-v1'

export async function cacheData(key: string, data: any) {
  try {
    if ('indexedDB' in window) {
      // IndexedDB 사용
      const request = indexedDB.open('kaching-db', 1)
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result
        if (!db.objectStoreNames.contains('cache')) {
          db.createObjectStore('cache', { keyPath: 'key' })
        }
      }
      request.onsuccess = (event) => {
        const db = (event.target as IDBOpenDBRequest).result
        const transaction = db.transaction(['cache'], 'readwrite')
        const store = transaction.objectStore('cache')
        store.put({ key, data, timestamp: Date.now() })
      }
    } else {
      // localStorage 폴백
      localStorage.setItem(`cache_${key}`, JSON.stringify({ data, timestamp: Date.now() }))
    }
  } catch (error) {
    console.error('Cache error:', error)
  }
}

export async function getCachedData(key: string, maxAge: number = 3600000): Promise<any | null> {
  try {
    if ('indexedDB' in window) {
      return new Promise((resolve) => {
        const request = indexedDB.open('kaching-db', 1)
        request.onsuccess = (event) => {
          const db = (event.target as IDBOpenDBRequest).result
          const transaction = db.transaction(['cache'], 'readonly')
          const store = transaction.objectStore('cache')
          const getRequest = store.get(key)
          getRequest.onsuccess = () => {
            const result = getRequest.result
            if (result && Date.now() - result.timestamp < maxAge) {
              resolve(result.data)
            } else {
              resolve(null)
            }
          }
          getRequest.onerror = () => resolve(null)
        }
        request.onerror = () => resolve(null)
      })
    } else {
      const cached = localStorage.getItem(`cache_${key}`)
      if (cached) {
        const parsed = JSON.parse(cached)
        if (Date.now() - parsed.timestamp < maxAge) {
          return parsed.data
        }
      }
      return null
    }
  } catch (error) {
    console.error('Get cache error:', error)
    return null
  }
}

export function isOnline(): boolean {
  return navigator.onLine
}

export function onOnlineStatusChange(callback: (online: boolean) => void) {
  window.addEventListener('online', () => callback(true))
  window.addEventListener('offline', () => callback(false))
}

export async function queueRequest(url: string, options: RequestInit) {
  // 오프라인 요청 큐에 추가
  const queue = JSON.parse(localStorage.getItem('request-queue') || '[]')
  queue.push({ url, options, timestamp: Date.now() })
  localStorage.setItem('request-queue', JSON.stringify(queue))
}

export async function processQueue() {
  if (!isOnline()) return

  const queue = JSON.parse(localStorage.getItem('request-queue') || '[]')
  if (queue.length === 0) return

  const processed: number[] = []
  
  for (let i = 0; i < queue.length; i++) {
    const item = queue[i]
    try {
      await fetch(item.url, item.options)
      processed.push(i)
    } catch (error) {
      console.error('Queue processing error:', error)
    }
  }

  // 처리된 항목 제거
  const remaining = queue.filter((_: any, idx: number) => !processed.includes(idx))
  localStorage.setItem('request-queue', JSON.stringify(remaining))
}

